<template>
  <a-spin :spinning="spinning">
    <a-form :form="form">
      <a-form-item label="题型" v-bind="formItemLayout">
        <a-radio-group
          name="radioGroup"
          v-decorator="[
            'type',
            {
              initialValue: 1
            }
          ]">
          <a-radio :value="1">
            单选题
          </a-radio>
          <a-radio :value="2">
            多选题
          </a-radio>
          <a-radio :value="3">
            填空题
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="题目" v-bind="formItemLayout">
        <a-textarea
          name="question"
          auto-size
          v-decorator="['question', { rules: [{ required: true, message: '请输入题目' }] }]"
        />
      </a-form-item>
      <template v-if="form.getFieldValue('type') !== 3">
        <a-form-item
          v-for="(k, index) in form.getFieldValue('keys')"
          :key="k"
          v-bind="formItemLayout"
          :label="'选项'+optionArr[k]"
          :required="false"
        >
          <a-textarea
            auto-size
            v-decorator="[
              `answer[${k}]`,
              {
                validateTrigger: ['change', 'blur'],
                rules: [
                  {
                    required: true,
                    whitespace: true,
                    message: '请输入选项' + optionArr[k],
                  },
                ],
              },
            ]"
            placeholder="请输入选项"
            style="width: 90%; margin-right: 8px"
          />
          <a-icon
            v-if="index === form.getFieldValue('keys').length - 1"
            class="dynamic-delete-button"
            type="minus-circle-o"
            @click="() => remove(k)"
          />
        </a-form-item>
        <a-form-item v-bind="formItemLayoutWithOutLabel">
          <a-button type="dashed" style="width: 60%" @click="add">
            <a-icon type="plus" /> 添加选项
          </a-button>
        </a-form-item>
      </template>
      <a-form-item label="答案" v-bind="formItemLayout" v-if="form.getFieldValue('type') === 1">
        <a-radio-group
          v-decorator="['correct', { rules: [{ required: true, message: '请选择答案' }] }]"
        >
          <a-radio v-for="option in optionArr" :key="option" :value="option">
            {{ option }}
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="答案" v-bind="formItemLayout" v-if="form.getFieldValue('type') === 2">
        <a-checkbox-group
          v-decorator="['correct', { rules: [{ required: true, message: '请选择答案' }] }]"
        >
          <a-checkbox v-for="option in optionArr" :key="option" :value="option">
            {{ option }}
          </a-checkbox>
        </a-checkbox-group>
      </a-form-item>
      <a-form-item label="答案" v-bind="formItemLayout" v-if="form.getFieldValue('type') === 3">
        <a-input
          name="answer"
          auto-size
          v-decorator="['correct', { rules: [{ required: true, message: '请输入答案' }] }]"
        />
      </a-form-item>
      <a-form-item label="排序" v-bind="formItemLayout" help="默认0，值越大越靠前">
        <a-input
          name="order"
          v-decorator="[
            'order',
            {
              initialValue: 0
            }
          ]"
        />
      </a-form-item>
      <a-form-item label="状态" v-bind="formItemLayout" help="是否在前端展示，默认展示">
        <a-switch
          checked-children="展示"
          un-checked-children="隐藏"
          name="state"
          v-decorator="[
            'state',
            {
              valuePropName: 'checked',
              initialValue: true
            }
          ]"
        />
      </a-form-item>
    </a-form>
  </a-spin>
</template>

<script>
import pick from 'lodash.pick'
import { ImgUpload } from '@/components'
import { requestGet, requestPost, requestPut } from '@/api/api'
const fields = ['id', 'name', 'href', 'logo', 'order', 'state']
let id = 0
export default {
    name: 'ModelForm',
    props: {
        pid: {
            type: Number,
            default: null
        },
        id: {
            type: Number,
            default: null
        }
    },
    components: {
        ImgUpload
    },
    data () {
        return {
            optionArr: [],
            radioStyle: {
                display: 'block',
                height: '30px',
                lineHeight: '30px'
            },
            spinning: false, // 页面加载
            formItemLayout: {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 7 }
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 13 }
                }
            },
            formItemLayoutWithOutLabel: {
                wrapperCol: {
                    xs: { span: 24, offset: 0 },
                    sm: { span: 13, offset: 7 }
                }
            }
        }
    },
    beforeCreate () {
        this.form = this.$form.createForm(this)
        this.form.getFieldDecorator('keys', { initialValue: [], preserve: true })
    },
    mounted () {
        if (this.aid) {
            this.getInfo(this.aid) // 获取编辑友链信息
        }
    },
    methods: {
        remove (k) {
            const { form } = this
            const keys = form.getFieldValue('keys')
            if (keys.length === 0) {
                return
            }
            id--
            const optionArr = []
            for (var i = 0; i < id; i++) {
                optionArr.push(String.fromCharCode((65 + i)))
            }
            this.optionArr = optionArr
            form.setFieldsValue({
                keys: keys.filter(key => key !== k)
            })
        },

        add () {
            const { form } = this
            const keys = form.getFieldValue('keys')
            const nextKeys = keys.concat(id++)
            const optionArr = []
            for (var i = 0; i < id; i++) {
                optionArr.push(String.fromCharCode((65 + i)))
            }
            this.optionArr = optionArr
            form.setFieldsValue({
                keys: nextKeys
            })
        },
        /**
         * 获取编辑友链信息
         * @id
         */
        getInfo (id) {
            this.spinning = true
            requestGet('/exams/papers/' + id)
                .then(res => {
                    res.result.state = res.result.state === 1
                    setTimeout(() => {
                        this.form.setFieldsValue(pick(res.result, fields))
                    }, 1000)
                })
                .finally(() => {
                    this.spinning = false
                })
        },
        /**
         * 提交按钮
         * form表单提交
         * @form
         */
        onOk () {
            const {
                form: { validateFields }
            } = this
            return new Promise(resolve => {
                validateFields((errors, values) => {
                    if (!errors) {
                        values.state = values.state ? 1 : 2 // 状态 1正常 2隐藏
                        if (this.aid) {
                            const url = '/exams/papers/' + this.aid
                            values.id = this.aid
                            requestPut(url, values)
                                .then(res => {
                                    this.$notification.success({
                                        message: '提示',
                                        description: res.msg,
                                        duration: 2
                                    })
                                    resolve(true)
                                })
                        } else {
                            values.paper_id = this.pid
                            const url = '/exams/papers/create'
                            requestPost(url, values)
                                .then(res => {
                                    this.$notification.success({
                                        message: '提示',
                                        description: res.msg,
                                        duration: 2
                                    })
                                    resolve(true)
                                })
                        }
                    }
                })
            })
        },
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>
